import { initializeNewRelicBrowser } from '@/lib/observability/new-relic-browser-init'

// Next.js loads instrumentation-client before the application becomes
// interactive. The npm agent works for static routes and global-error, unlike
// server-generated browser injection. SoftNav observes App Router navigation.
initializeNewRelicBrowser()
